import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["transform"]
const _hoisted_2 = ["transform"]
const _hoisted_3 = ["transform"]
const _hoisted_4 = ["transform"]
const _hoisted_5 = {
  key: 1,
  class: "qtl-sort-icon",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

import { computed } from "vue";
import { TableHeaderCellDataType } from "@/models/etc/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'QTLiteSortIcon',
  props: {
    dataType: {},
    order: {}
  },
  setup(__props: any) {

const DT = TableHeaderCellDataType;

const props = __props;

// Убывание (order 3): по нему меняем порядок правого глифа (цифры/буквы/полоски),
// стрелка при этом всегда смотрит вниз.
const isDesc = computed(() => props.order === 3);
// активна (зелёная), когда есть направление сортировки (возрастание или убывание)
const active = computed(() => props.order > 1);
// свой значок по типу показываем только в активном состоянии. Неактивный (серый)
// значок всегда обычный двухстрелочный, независимо от типа данных колонки.
// Дата (DateTime) использует тот же логический значок (полоски), что и Boolean.
const isTyped = computed(
  () =>
    active.value &&
    (props.dataType === DT.String ||
      props.dataType === DT.Number ||
      props.dataType === DT.Boolean ||
      props.dataType === DT.DateTime),
);

return (_ctx: any,_cache: any) => {
  return (isTyped.value)
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        class: _normalizeClass(["qtl-sort-icon", active.value ? 'qtl-sort-icon--active' : 'qtl-sort-icon--idle']),
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _cache[10] || (_cache[10] = _createElementVNode("path", {
          d: "M2 10.6667L4.66667 13.3334L7.33333 10.6667",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)),
        _cache[11] || (_cache[11] = _createElementVNode("path", {
          d: "M4.66663 13.3334V2.66669",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)),
        (_ctx.dataType === _unref(DT).String)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("g", {
                transform: isDesc.value ? 'translate(0, 6.6666)' : ''
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("path", {
                  d: "M13.3333 5.33331H10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1),
                _createElementVNode("path", {
                  d: "M10 6.66669V4.33335C10 3.89133 10.1756 3.4674 10.4882 3.15484C10.8007 2.84228 11.2246 2.66669 11.6667 2.66669C12.1087 2.66669 12.5326 2.84228 12.8452 3.15484C13.1577 3.4674 13.3333 3.89133 13.3333 4.33335V6.66669",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1)
              ]), 8, _hoisted_1),
              _createElementVNode("g", {
                transform: isDesc.value ? 'translate(0, -6.6666)' : ''
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("path", {
                  d: "M10 9.33331H13.3333L10 13.3333H13.3333",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1)
              ]), 8, _hoisted_2)
            ], 64))
          : (_ctx.dataType === _unref(DT).Number)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("g", {
                  transform: isDesc.value ? 'translate(0, 6.6666)' : ''
                }, _cache[2] || (_cache[2] = [
                  _createElementVNode("path", {
                    d: "M12.6667 4.00002C12.6667 3.26364 12.0697 2.66669 11.3333 2.66669C10.597 2.66669 10 3.26364 10 4.00002V5.33335C10 6.06973 10.597 6.66669 11.3333 6.66669C12.0697 6.66669 12.6667 6.06973 12.6667 5.33335V4.00002Z",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, -1)
                ]), 8, _hoisted_3),
                _createElementVNode("g", {
                  transform: isDesc.value ? 'translate(0, -6.6666)' : ''
                }, _cache[3] || (_cache[3] = [
                  _createElementVNode("path", {
                    d: "M11.3333 13.3333V9.33331H10",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, -1),
                  _createElementVNode("path", {
                    d: "M10 13.3333H12.6667",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, -1)
                ]), 8, _hoisted_4)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (!isDesc.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[4] || (_cache[4] = _createElementVNode("path", {
                        d: "M7.33337 2.66669H10",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1)),
                      _cache[5] || (_cache[5] = _createElementVNode("path", {
                        d: "M7.33337 5.33331H12",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1)),
                      _cache[6] || (_cache[6] = _createElementVNode("path", {
                        d: "M7.33337 8H14",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[7] || (_cache[7] = _createElementVNode("path", {
                        d: "M7.33337 8H10",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1)),
                      _cache[8] || (_cache[8] = _createElementVNode("path", {
                        d: "M7.33337 5.33337H12",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1)),
                      _cache[9] || (_cache[9] = _createElementVNode("path", {
                        d: "M7.33337 2.66669H14",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1))
                    ], 64))
              ], 64))
      ], 2))
    : (_openBlock(), _createElementBlock("svg", _hoisted_5, [
        _createElementVNode("g", {
          class: _normalizeClass(_ctx.order === 2 ? 'qtl-sort-icon--active' : 'qtl-sort-icon--idle')
        }, _cache[12] || (_cache[12] = [
          _createElementVNode("path", {
            d: "M2 10.6666L4.66667 13.3333L7.33333 10.6666",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, -1),
          _createElementVNode("path", {
            d: "M4.66669 13.3333V2.66663",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, -1)
        ]), 2),
        _createElementVNode("g", {
          class: _normalizeClass(_ctx.order === 3 ? 'qtl-sort-icon--active' : 'qtl-sort-icon--idle')
        }, _cache[13] || (_cache[13] = [
          _createElementVNode("path", {
            d: "M14 5.33329L11.3334 2.66663L8.66669 5.33329",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, -1),
          _createElementVNode("path", {
            d: "M11.3333 2.66663V13.3333",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, -1)
        ]), 2)
      ]))
}
}

})